import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=4aa1ed4e&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=4aa1ed4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa1ed4e",
  null
  
)

export default component.exports